export const CURRENCY_LIST = [
  {
    id: "USD",
    name: "USD",
  },
];
